<template>
  <div class="cx_control" :class="{ cx_control_has_value: hasValue }" @mouseover="onMouseOver" @mouseout="onMouseOut">
    <div class="cx_control_caption" v-if="title != undefined && title != ''" :style="{'height': height + 'px'}"><span>{{translatedTitle}}</span>
    <span  v-if="required && !keyfield" class="cx_required" :class="{cx_required_active: isEdit}">★</span>    
    <i  v-if="keyfield" class="material-icons small valign">vpn_key</i>
    <i  v-if="tooltip" class="material-icons small valign help" ref="tooltip_target">help_outline</i>
    </div>
    <div class="cx_control_input">
      <div v-if="isDirectEdit==false && isEdit == false" :style="{'height': height + 'px'}" :class="{cx_vertical_center: !title}" ref="copy_target" class="cx_control_input_read">
        <slot name="read"></slot>
      </div>
      <div v-if="isDirectEdit || isEdit" ref="target" :style="{'height': height + 'px'}" :class="{cx_vertical_center: !title}">
        <slot name="edit"></slot>
        <div class="cx_control_validation" v-if="validator !=null && validator.isValidationMode">{{validator==null? '' : validator.validateMessage}}</div>
      </div>
    </div>
      <!-- マルチラインテキストボックスの場合、スクロールバーが左右に移動しないよう対応 -->
      <div :class="{cx_vertical_center: !title}">
        <div class="cx_control_buttons" :class="{'editActive' : isActive, 'cx_control_buttons_multiline' : isMultilineText, cx_control_fixedwidth: provider != null }" ref="buttons">
          <i v-if="isDirectEdit" class="material-icons small valign commit"  @click="onDirectCommit">check</i>
          <i v-if="isDirectEdit" class="material-icons small valign close"  @click="onDirectClose">close</i>                
          <i v-if="isDirectEdit==false && isEdit == false && editButtonVisible && isDirectEditEnabled" class="material-icons small valign edit" :class="{disabled : editButtonEnabled == false}" @click="onDirectEdit">edit</i>
          <i v-if="isDirectEdit==false && isEdit == false && editButtonVisible && !isDirectEditEnabled" class="material-symbols-outlined small valign edit stronger" :class="{disabled : editButtonEnabled == false}" @click="onDirectEdit">edit_note</i>
          <i v-if="isDirectEdit==false && isEdit == false && editButtonVisible" class="material-icons small valign edit" ref="copy_button"  @click="onCopy">content_copy</i>     
          <slot name="func" v-if="isDirectEdit==false && isEdit == false  && editButtonVisible && editButtonEnabled && isDirectEditEnabled" ></slot>      
          <!-- custom-classはこのバージョンでは使えない -->
          <b-popover custom-class="copy_popover" @show="onPopuped" ref="popup"  :target="target" boundary="window" placement="top"  v-if="copyPopover" :show="copyPopover"><span>コピーされました</span></b-popover>              
        </div>  
      </div>  
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class Control extends Vue {
  @Prop() public isEdit!: boolean;
  @Prop({default:false}) public hasValue: boolean;
  @Prop() public title?: string;
  @Prop({ default: 36 }) public height: number;
  @Prop({ default: null }) public validator: Components.ControlValidator;
  @Prop({default:null}) public provider: Components.IDirectEditProvider;
  @Prop({default:null}) public editor: Vue;  
  @Prop({default:false}) public enabled: boolean;
  @Prop() public tooltip?: string;
  @Prop({default:false}) public isMultilineText: boolean;
  @Prop({default:false}) public required: boolean;
  @Prop({default:false}) public keyfield: boolean; 
  @Prop({default:true}) public isDirectEditEnabled: boolean;    
  // @Prop({default:false}) public adjustHeight: boolean;
  // //InValidの場合だけ高さを14px高くして表示する
  // public get adjustedHeight(){
  //   if (this.adjustHeight == false || (this.validator && this.validator.validateMessage)) return this.height;
  //   else return this.height - 6;
  // }
  target : HTMLElement;
  copyPopover: boolean = false;

  public get editButtonEnabled() : boolean {
    return this.enabled && this.provider != null && this.provider.hasDirectPerm();
  }
  public get editButtonVisible() :boolean {
    return this.provider != null &&  (this.provider as any).isDirectEditting == false;
  }
  public created(){
    this.translatedTitle = this.$translate(this.title);
  }
  public mounted() {
    if(this.tooltip) this.$nextTick(()=>{
      if (this.$refs.tooltip_target == null) return;//空の場合がある
      this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip);      
    });
  }

  public translatedTitle = '';
  public isDirectEdit :boolean = false;
  public isActive: boolean = false;
  private onDirectEdit(){
    //編集値のクローンが必要
    if (this.editButtonEnabled == false) return;
    // DirectEditが不可の項目の鉛筆をクリックしたら全体編集モードに移行する
    if (!this.isDirectEditEnabled) {
      if((this.editor as Components.Editor).owner.dialogMode) (this.editor as Components.Editor).owner.onEdit(false);
      else (this.editor as Components.Editor).owner.onOpenDialog();
      return;
    }
    this.$api.sckeys.filter = (key:string) =>key == "F9" || key == "F12";

    this.provider.onDirectEdit();
    this.isDirectEdit = true;
    document.body.addEventListener('click', this.onClickOtherElement, { capture: true });

    this.$nextTick(()=>{
      var focussableElements = 'a:not([disabled]), button:not([disabled]),select:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';

      var focussable = (this.$refs.target as HTMLElement).querySelectorAll(focussableElements);
      if (focussable != null && focussable.length > 0) {
        const input = focussable[0] as HTMLElement;
        input.focus();
      }
    });

  }
  private onDirectCommit(){
    //バリデーションをパスしたらコミット=>クローズ
    if (this.validator.validate()){
      this.provider.onDirectCommit();
      this.isDirectEdit = false;
      document.body.removeEventListener('click', this.onClickOtherElement,{ capture: true });
      this.$api.sckeys.filter = null;
    }
  }
  private onDirectClose(){
     this.provider.onDirectClose();
     this.isDirectEdit = false;
     document.body.removeEventListener('click', this.onClickOtherElement,{ capture: true });
    this.$api.sckeys.filter = null;     
     this.validator.reset();
  }

  private onMouseOver(){
    this.isActive = true;
  }
  private onMouseOut(){
    this.isActive = false;
  }
  private onCopy(){
    var content = (this.$refs.copy_target as HTMLElement).innerText;
    (navigator as any).clipboard.writeText(content);

    this.target = this.$refs.copy_button as HTMLElement;
    this.copyPopover = true;    
  }
  public onClickOtherElement(e: any) {
      
      const modal = document.getElementById('builtinModal');
      const modal2 = document.getElementById('popupEditor');
      const modal3 = document.getElementById('workflowDialog');            
      if (modal != null && modal.contains(e.srcElement)) return;
      if (modal2 != null && modal2.contains(e.srcElement)) return;        
      if (modal3 != null && modal3.contains(e.srcElement)) return;
      

      // if (this.$el.contains(e.srcElement) == false && this.isDirectEdit && (e.srcElement.lastChild != null &&  e.srcElement.lastChild.id == 'spinner') == false) {
      if (this.$el.contains(e.srcElement) == false && (this.editor == null || this.editor.$el.querySelector('.cx_tabcontent').contains(e.srcElement) == false) && this.isDirectEdit) {       
        //this.onDirectClose();
        this.$api.modal.showDialog('確認メッセージ','編集中のデータは保存されていません。破棄してもよろしいですか?',false, '破棄する','戻る')
          .then(()=>{this.onDirectClose(); e.srcElement.click();}); //フォーカスは戻せない(focusinを使用すればできるかもしれない)

          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
      } 
    }
    public onPopuped(){
      console.log((this.$refs.popup as any)._toolpop.$tip.className);
      (this.$refs.popup as any)._toolpop.$tip.className += " copy_popover";
    }
}

</script>
<style lang="scss">
.cx_control {
  /* height: 40px; */
  display: flex;
  font-size:14px;
  color:#2C304F;
  .cx_control_buttons{
    &.cx_control_fixedwidth{
    width: 44px;
    }


    i {
      border:1px solid transparent;
      cursor:pointer;
      border-radius:2px;
      margin-left:2px;
      // color: lightgray;
      &.disabled{
        // opacity: 0.2;
        color: lightgray; //不要なスタッキングコンテクストの削除
        cursor:default;
      }
    }

    i:hover:not(.disabled) {
      // color: #2c3e50;
      border:1px solid lightgray;
    }

    i:active:not(.disabled) {
      color: #007bff;
      border:1px solid lightgray;
    }    


    .edit {
      display:none;      
    }
    &.editActive{
      .edit {
        display:inline-block;
      }
    }
    .commit {
      color: green;      

    }
    .close {
      color:red;
      padding-top:1px;      
    }
    .stronger {
      font-variation-settings:
      'FILL' 0,
      'wght' 700,
      'GRAD' 200,
      'opsz' 40;
    }
  } 
  // マルチラインテキストボックスの場合、ボタンエリアを指定
  .cx_control_buttons_multiline{
    // width: 22px;
  } 

  .form-control.is-invalid {
    background-image: unset !important;
  }
}

.cx_control_caption {
  // flex: 0.3;
  width: 150px;
  text-align: left;
  vertical-align: bottom;
  margin-right: 10px;
  white-space: pre;
  overflow: hidden;
  height:36px;
  // background-color: red;
  .cx_required{
    font-size: 12px;
    vertical-align: top;
    margin-left: 1px;
    margin-right: 1px;

    &.cx_required_active{
      color:#f3342d;
    }
  }
  .has_tooltip{
    border-bottom:dotted;/*下線を点線にする*/
    border-color:rgb(121, 120, 120);
    border-width:1px;
    cursor: pointer;
  }

    i.small {
      margin-left:2px;
      margin-bottom:3px;
      margin-right:0px;
      font-size: 15px;
      color:#9e9d9d;      

      &.help:hover{
        color:#007bff;                
        cursor:pointer;
      }      

    }  
}
.cx_list_container{
  .cx_control{
    .cx_vertical_center{
      display:flex;
      flex-direction: column;
      justify-content: start;
    }
  }
}
.cx_control {
  .cx_vertical_center{
    display:flex;
    flex-direction: column;
    justify-content: center;
  }  
}
.cx_control_input {
  flex: 1;
  text-align: left;
  // padding-right: 20px;
  vertical-align: bottom;
  // margin-bottom: 5px;
  overflow-x: hidden;
  overflow-y: hidden;
  min-width: 120px;
  
  .cx_control_input_read{
    span{
      white-space: nowrap;
    }
  }

  .form-control-sm {
    height: 22px;
    padding: 1px 5px;
    font-size: 13px;
    border-radius: 0.2rem;
    outline: none;
    box-shadow: none;
  }

  .custom-select-sm {
    height: 22px;
    padding-top: 1px;
    padding-bottom: 1px;
    padding-left: 5px;
    font-size: 13px;
    margin-bottom: 0px !important;
      outline: none;
    box-shadow: 1px;
  }
 
}
.cx_control_validation {
  font-size: 7pt;
  margin-top: 0px;
  color:  red;

}
input.invalid {
  border-color: red;
}
select.invalid {
  border-color: red;
}
.copy_popover{
  background-color:#ffffff !important;  
  font-size:12px;
  .popover-body{
    padding: 5px 8px;
  }
  .arrow::after {
    border-top-color:#ffffff !important;  
  }
}
</style>


    

